import React from 'react';
import { withRouter } from 'react-router-dom';

import BaseComponent from 'ergonomics/components/BaseComponent';

import User from 'ergonomics/assets/images/user-arms.svg';
import WorkTable from 'ergonomics/assets/images/table-work.svg';
import UserCorrectImg from 'ergonomics/assets/images/user-neck.svg';

const Arms = () => {
  const correctAssetsMap = {
    userCorrectImg: UserCorrectImg,
    userClassName: 'user-keyboard-on-table',
  };

  return (
    <>
      <div className="info-box-wrap">
        <BaseComponent
          beforeClicked="elbow"
          afterClicked="elbow-clicked"
          userClassName="user-arms-screen"
          pcClassName="pc-position"
          UserImg={User}
          CorrectAssetsMap={correctAssetsMap}
          PCImg={WorkTable}
          current="Arms"
          currentPage={2}
          nextLink="neck"
        />
      </div>
    </>
  );
};

export default withRouter(Arms);
